import React from 'react';
import useCachedImgURL from './useCachedImgURL';
const CachedImg = ({ src, ...imgProps }) => {
    const cachedSrc = useCachedImgURL(src);
    return (React.createElement("img", { src: cachedSrc.data, ...imgProps }));
};
export default CachedImg;
